export default __webpack_public_path__ + "static/media/img_step_lucia09_w.8cc61856.jpg";